var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000166659060393468183600000000504527205354155152_);}\n\t.st3{fill:url(#SVGID_00000010301260751945371130000006366914041710381964_);}\n\t.st4{fill:url(#SVGID_00000052094579856459280360000013805299471946945947_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.8189,
    y1: 174.5464,
    x2: 576.4489,
    y2: 661.5765,
    gradientTransform: "matrix(1 0 0 1 0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B5998"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M789.02,934.6c-192.49,20.54-385.56,20.54-578.05,0c-76.75-8.19-137.38-68.82-145.57-145.58 c-20.54-192.49-20.54-385.55,0-578.04c8.19-76.75,68.82-137.38,145.57-145.57c192.49-20.54,385.55-20.54,578.04,0 c76.76,8.19,137.38,68.82,145.58,145.57c20.54,192.49,20.54,385.55,0,578.04C926.4,865.78,865.78,926.4,789.02,934.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124865646491035562180000000945983066487216063_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.7303,
    y1: 615.3074,
    x2: -116.0198,
    y2: 74.7375,
    gradientTransform: "matrix(1 0 0 1 0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3457A0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F3F77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124865646491035562180000000945983066487216063_)"
    },
    d: "M885.64,243.53 c-7.26-68.11-61.06-121.91-129.17-129.18c-170.81-18.22-342.13-18.22-512.94,0c-68.11,7.27-121.91,61.07-129.18,129.18 c-18.22,170.81-18.22,342.13,0,512.93c7.27,68.12,61.07,121.91,129.18,129.18c170.81,18.23,342.13,18.23,512.93,0 c68.12-7.26,121.91-61.06,129.18-129.18C903.87,585.66,903.87,414.34,885.64,243.53L885.64,243.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067954091881183712060000008272932677288256402_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.012,
    y1: 800.125,
    x2: 500.012,
    y2: 921.915,
    gradientTransform: "matrix(1 0 0 1 0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3457A0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F3F77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067954091881183712060000008272932677288256402_)"
    },
    d: "M63.49,770.36 c0.62,6.22,1.26,12.44,1.92,18.66c8.19,76.75,68.82,137.38,145.58,145.57c192.49,20.54,385.55,20.54,578.04,0 c76.76-8.19,137.38-68.82,145.57-145.57c0.67-6.22,1.3-12.44,1.93-18.66H63.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151534329265125588660000003928212897129902772_",
    gradientUnits: "userSpaceOnUse",
    x1: 1083.2036,
    y1: 791.2516,
    x2: 458.5338,
    y2: 476.2717,
    gradientTransform: "matrix(1 0 0 1 0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3457A0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#2A4C8D",
      stopOpacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#22427D",
      stopOpacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F3F77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151534329265125588660000003928212897129902772_)"
    },
    d: "M655.07,199.89 c-78.41,0-141.98,63.57-141.98,141.98v106.05h-76.41v131.31l76.41,68.44v302.29c92.02-0.45,184.04-5.56,275.94-15.37 c76.76-8.19,137.38-68.82,145.57-145.58c15.28-143.22,19.19-286.76,11.73-430.14L787.34,199.88H655.07V199.89z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.09,949.97c52.44-0.25,104.87-2.03,157.28-5.33v-365.4h104.36l12.61-131.31H670.38v-83.38 c0-18.42,14.93-33.34,33.34-33.34h83.62V199.89H655.07c-78.41,0-141.98,63.57-141.98,141.98v106.05h-76.41v131.31h76.41 L513.09,949.97L513.09,949.97z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a088678e532e56e5e66a368ec66c01ef.svg";
export { ForwardRef as ReactComponent };